import React from 'react';
import * as Icon from 'react-feather';

import PermissionCode from '@modules/roles/contantsPermissions';
import { IRouter } from '@routers/interface';

export const routerReports: IRouter = {
  path: '/reports',
  loader: React.lazy(() => import('./index')),
  exact: true,
  menu: {
    icon: <Icon.Edit />,
  },
  name: 'reports.name', //translate here for breadcrumb and sidebar
  permissionCode: PermissionCode.REPORTS_SEARCH,
};
